import { useMemo } from "react"
import { clamp } from "lodash"
import { DEFAULT_VENUE_FILTER } from "constant"
import { useVenue } from "providers/venue"
import { useIndoorMap } from "providers/venue/modules/indoormap/hooks/useIndoorMap"
import { getSuitablyValueBetweenBearings } from "components/IndoorMap"
import { useGeoLocation } from "providers/geolocation"
import { UseGetUserLocationView } from "./interface"

export const useGetUserLocationView: UseGetUserLocationView = () => {
  const { dataLoaded } = useVenue()
  const { indoorRef, mapLoaded } = useIndoorMap()
  const { userLocation, locationVenue } = useGeoLocation()

  const mapReady = indoorRef?.current && mapLoaded && dataLoaded

  const userLocationView = useMemo(() => {
    if (!mapReady || !userLocation) return null

    const indoorMap = indoorRef.current
    const currentBearing = indoorMap.getBearing()
    const targetBearing = indoorRef.current.defaultBearing
    const bearing = getSuitablyValueBetweenBearings(
      targetBearing,
      currentBearing
    )
    const pitch = indoorRef.current.defaultPitch
    const locationExtent = indoorMap.getFeatureExtent(userLocation)
    // Check if location's venue has geometry before retrieving feature extent to prevent function errors
    const canCalculateFeatureExtent =
      locationVenue?.id && locationVenue?.id !== DEFAULT_VENUE_FILTER
    const venueExtent = canCalculateFeatureExtent
      ? indoorMap.getFeatureExtent(locationVenue)
      : null
    const center = indoorMap.getExtentCenter(locationExtent)
    const defaultZoom =
      indoorRef.current.defaultZoom ?? indoorMap.getExtentZoom(venueExtent)
    const zoom = clamp(defaultZoom, 19.5, 21)

    return {
      center,
      zoom,
      bearing,
      pitch,
    }
  }, [indoorRef, userLocation, locationVenue, mapReady])

  return userLocationView
}
